const snordeluxeAssets = {
  'Animal': {
    image: 'assets/snordeluxe_images/Animal/Animal.webp',
    battleImage: 'assets/snordeluxe_images/Animal/animal_nobg.png',
    coins: 100, gems: 1,
    level: 1,
    evolution: 'Beast',
    hitpoints: 100,
    weight: 10,
    analysis: 'Animal is a wild and untamed Snordeluxe variant that relies on its primal instincts. Animal is a race that has lasted over 2 billion years and has conquered many dimensions over time.',
    attacks: {
      basic: { damage: 10, probability: 0.9, label: "Scratch", description: "A basic scratch attack.", training_cost: 0 },
      special: { damage: 30, probability: 0.5, label: "Roar of the Wild", description: "A powerful roar that terrifies enemies.", training_cost: 5 }
    }
  },
  'Beast': {
    image: 'assets/snordeluxe_images/Beast/Beast.webp',
    battleImage: 'assets/snordeluxe_images/Beast/beast_nobg.png',
    mana: 1,
    level: 2,
    evolution: 'Wild',
    hitpoints: 220,
    weight: 22,
    analysis: 'Beast is an evolved version of Animal, exhibiting increased strength and savagery. After 1 billion years the animal race has evolved into a Beast.',
    attacks: {
      basic: { damage: 20, probability: 0.9, label: "Savage Bite", description: "A ferocious bite.", training_cost: 0 },
      special: { damage: 50, probability: 0.5, label: "Feral Roar", description: "An intense roar that can paralyze opponents.", training_cost: 10 }
    }
  },
  'Wild': {
    image: 'assets/snordeluxe_images/Wild/Wild.webp',
    battleImage: 'assets/snordeluxe_images/Wild/wild_nobg.png',
    mana: 2,
    level: 3,
    hitpoints: 500,
    weight: 30,
    analysis: 'Wild is the ultimate form of the Animal variant, harnessing raw power and ferocity. After 3 billion years this has formed into a new race that is hardly noticeable as Animal.',
    attacks: {
      basic: { damage: 30, probability: 0.9, label: "Wild Slash", description: "A slashing attack fueled by wild energy.", training_cost: 0 },
      special: { damage: 70, probability: 0.5, label: "Untamed Fury", description: "An uncontrollable burst of energy.", training_cost: 15 }
    }
  },
  'Glitch': {
    image: 'assets/snordeluxe_images/Glitch/Glitch.webp',
    battleImage: 'assets/snordeluxe_images/Glitch/glitch_nobg.png',
    coins: 120, gems: 2,
    level: 1,
    evolution: 'Hacker',
    hitpoints: 80,
    weight: 8,
    analysis: 'Glitch is a digital anomaly, causing unpredictable effects in the virtual realm.',
    attacks: {
      basic: { damage: 19, probability: 0.88, label: "Byte Bash", description: "A basic digital attack.", training_cost: 0 },
      special: { damage: 38, probability: 0.45, label: "System Crash", description: "A devastating crash attack.", training_cost: 5 }
    }
  },
  'Hacker': {
    image: 'assets/snordeluxe_images/Hacker/Hacker.webp',
    battleImage: 'assets/snordeluxe_images/Hacker/hacker_nobg.png',
    mana: 1,
    level: 2,
    evolution: 'Wifi',
    hitpoints: 190,
    weight: 18,
    analysis: 'Hacker Snordeluxe manipulates code to its advantage, disrupting opponents.',
    attacks: {
      basic: { damage: 28, probability: 0.88, label: "Hack Attack", description: "A clever attack using hacking skills.", training_cost: 0 },
      special: { damage: 69, probability: 0.45, label: "Code Overload", description: "An overwhelming attack using code.", training_cost: 10 }
    }
  },
  'Wifi': {
    image: 'assets/snordeluxe_images/Wifi/Wifi.webp',
    battleImage: 'assets/snordeluxe_images/Wifi/wifi-nobg.png',
    mana: 3,
    level: 3,
    hitpoints: 400,
    weight: 38,
    analysis: 'Wifi Snordeluxe dominates the digital airwaves, exerting control over data streams.',
    attacks: {
      basic: { damage: 56, probability: 0.88, label: "Signal Slam", description: "A powerful slam using signal waves.", training_cost: 0 },
      special: { damage: 100, probability: 0.45, label: "Wireless Wipeout", description: "A devastating wipeout attack.", training_cost: 15 }
    }
  },
  'Death': {
    image: 'assets/snordeluxe_images/Death/Death.webp',
    battleImage: 'assets/snordeluxe_images/Death/death_nobg.png',
    coins: 150, gems: 2,
    level: 1,
    evolution: 'Necromancer',
    hitpoints: 100,
    weight: 11,
    analysis: 'Death Snordeluxe harnesses the power of the afterlife, casting shadows over its foes.',
    attacks: {
      basic: { damage: 15, probability: 0.85, label: "Grim Claw", description: "A grim claw attack from beyond.", training_cost: 0 },
      special: { damage: 40, probability: 0.4, label: "Soul Reap", description: "A reaping attack that steals souls.", training_cost: 5 }
    }
  },
  'Necromancer': {
    image: 'assets/snordeluxe_images/Necromancer/Necromancer.webp',
    battleImage: 'assets/snordeluxe_images/Necromancer/necromancer_nobg.png',
    mana: 1,
    level: 2,
    evolution: 'Vampire',
    hitpoints: 220,
    weight: 22,
    analysis: 'Necromancer Snordeluxe commands the dead, using dark magic to control the battlefield.',
    attacks: {
      basic: { damage: 30, probability: 0.85, label: "Dark Magic", description: "A dark magic attack.", training_cost: 0 },
      special: { damage: 60, probability: 0.4, label: "Raise Dead", description: "An attack that raises the dead.", training_cost: 10 }
    }
  },
  'Vampire': {
    image: 'assets/snordeluxe_images/Vampire/Vampire.webp',
    battleImage: 'assets/snordeluxe_images/Vampire/vampire_nobg.png',
    mana: 3,
    level: 3,
    hitpoints: 400,
    weight: 32,
    analysis: 'Vampire Snordeluxe is a master of the night, draining life from its victims.',
    attacks: {
      basic: { damage: 45, probability: 0.85, label: "Blood Suck", description: "A blood-sucking attack.", training_cost: 0 },
      special: { damage: 80, probability: 0.4, label: "Eternal Night", description: "An attack that shrouds everything in eternal night.", training_cost: 15 }
    }
  },
  'Void': {
    image: 'assets/snordeluxe_images/Void/Void.webp',
    battleImage: 'assets/snordeluxe_images/Void/void_nobg.png',
    coins: 110, gems: 1,
    level: 1,
    evolution: 'Dark Matter',
    hitpoints: 100,
    weight: 9,
    analysis: 'Void Snordeluxe embodies the emptiness of space, its attacks drawing power from the void.',
    attacks: {
      basic: { damage: 11, probability: 0.89, label: "Abyssal Slash", description: "A slash attack from the abyss.", training_cost: 0 },
      special: { damage: 36, probability: 0.47, label: "Black Hole Burst", description: "An attack that harnesses the power of a black hole.", training_cost: 5 }
    }
  },
  'Dark Matter': {
    image: 'assets/snordeluxe_images/Dark Matter/Dark Matter.webp',
    // dark matter_nobg.png was accidentally a duplicate of the King's
    // sprite, so the in-battle Dark Matter looked identical to its
    // evolved form. Fall back to the (correct) .webp which clearly
    // shows the purple-swirl Dark Matter design.
    battleImage: 'assets/snordeluxe_images/Dark Matter/Dark Matter.webp',
    mana: 1,
    level: 2,
    evolution: 'Dark Matter King',
    hitpoints: 200,
    weight: 20,
    analysis: 'Dark Matter Snordeluxe manipulates dark energy, its attacks warping reality. ',
    attacks: {
      basic: { damage: 22, probability: 0.89, label: "Void Strike", description: "A strike attack using void energy.", training_cost: 0 },
      special: { damage: 56, probability: 0.47, label: "Dark Energy", description: "An attack that uses dark energy.", training_cost: 10 }
    }
  },
  'Dark Matter King': {
    image: 'assets/snordeluxe_images/Dark Matter King/Dark Matter King.webp',
    battleImage: 'assets/snordeluxe_images/Dark Matter King/dark matter king_nobg.png',
    mana: 3,
    level: 3,
    hitpoints: 400,
    weight: 40,
    analysis: 'Dark Matter King Snordeluxe is the ultimate form, commanding the universe with its power.',
    attacks: {
      basic: { damage: 33, probability: 0.89, label: "Cosmic Crush", description: "A crushing attack using cosmic power.", training_cost: 0 },
      special: { damage: 176, probability: 0.37, label: "Galactic Annihilation", description: "An attack that annihilates galaxies.", training_cost: 15 }
    }
  },
  'Life': {
    image: 'assets/snordeluxe_images/Life/Life.webp',
    battleImage: 'assets/snordeluxe_images/Life/life_nobg.png',
    coins: 130, gems: 2,
    level: 1,
    evolution: 'Angel',
    hitpoints: 100,
    weight: 11,
    analysis: 'Life Snordeluxe draws its power from nature, its attacks renewing the environment.',
    attacks: {
      basic: { damage: 12, probability: 0.87, label: "Nature's Strike", description: "A strike attack using natural energy.", training_cost: 0 },
      special: { damage: 38, probability: 0.46, label: "Bloom of Renewal", description: "An attack that causes a bloom of life.", training_cost: 5 }
    }
  },
  'Angel': {
    image: 'assets/snordeluxe_images/Angel/Angel.webp',
    battleImage: 'assets/snordeluxe_images/Angel/angel_nobg.png',
    mana: 1,
    level: 2,
    evolution: 'Emperor',
    hitpoints: 220,
    weight: 20,
    analysis: 'Angel Snordeluxe uses holy light to protect and heal its allies.',
    attacks: {
      basic: { damage: 24, probability: 0.87, label: "Holy Light", description: "A light-based attack.", training_cost: 0 },
      special: { damage: 58, probability: 0.46, label: "Divine Protection", description: "An attack that grants divine protection.", training_cost: 10 }
    }
  },
  'Emperor': {
    image: 'assets/snordeluxe_images/Emperor/Emperor.webp',
    battleImage: 'assets/snordeluxe_images/Emperor/emperor_nobg.png',
    mana: 3,
    level: 3,
    hitpoints: 450,
    weight: 35,
    analysis: 'Emperor Snordeluxe is the ultimate life form, its attacks embodying divine power.',
    attacks: {
      basic: { damage: 36, probability: 0.87, label: "Divine Strike", description: "A strike attack using divine power.", training_cost: 0 },
      special: { damage: 78, probability: 0.46, label: "Heaven's Wrath", description: "An attack that calls down heavenly wrath.", training_cost: 15 }
    }
  },
  'Fire': {
    image: 'assets/snordeluxe_images/Fire/Fire.webp',
    battleImage: 'assets/snordeluxe_images/Fire/fire_nobg.png',
    coins: 100, gems: 1,
    level: 1,
    evolution: 'Lava',
    hitpoints: 100,
    weight: 10,
    analysis: 'Fire Snordeluxe controls the element of fire, its attacks burning everything in its path.',
    attacks: {
      basic: { damage: 10, probability: 0.9, label: "Flame Punch", description: "A punch attack using fire.", training_cost: 0 },
      special: { damage: 30, probability: 0.5, label: "Fire Blast", description: "An attack that releases a blast of fire.", training_cost: 5 }
    }
  },
  'Lava': {
    image: 'assets/snordeluxe_images/Lava/Lava.webp',
    battleImage: 'assets/snordeluxe_images/Lava/craiyon_163757_image.png',
    mana: 1,
    level: 2,
    hitpoints: 200,
    weight: 24,
    analysis: 'Lava Snordeluxe harnesses molten rock, its attacks engulfing enemies in magma.',
    attacks: {
      basic: { damage: 20, probability: 0.9, label: "Lava Punch", description: "A punch attack using lava.", training_cost: 0 },
      special: { damage: 50, probability: 0.5, label: "Magma Surge", description: "An attack that causes a surge of magma.", training_cost: 10 }
    }
  },
  'Medic': {
    image: 'assets/snordeluxe_images/Medic/Medic.webp',
    battleImage: 'assets/snordeluxe_images/Medic/medic_nobg.png',
    coins: 110, gems: 1,
    level: 1,
    hitpoints: 400,
    weight: 12,
    analysis: 'Medic Snordeluxe focuses on healing and supporting its allies in battle.',
    attacks: {
      basic: { damage: 11, probability: 0.89, label: "First Aid Punch", description: "A punch that heals allies.", training_cost: 0 },
      special: { damage: 36, probability: 0.47, label: "Healing Surge", description: "An attack that releases a surge of healing energy.", training_cost: 5 }
    }
  },
  'Acid': {
    image: 'assets/snordeluxe_images/Acid/Acid.webp',
    battleImage: 'assets/snordeluxe_images/Acid/acid_nobg.png',
    coins: 110, gems: 1,
    level: 1,
    evolution: 'Nuclear',
    hitpoints: 100,
    weight: 11,
    analysis: 'Acid Snordeluxe uses corrosive attacks to weaken and dissolve its enemies.',
    attacks: {
      basic: { damage: 11, probability: 0.89, label: "Corrosive Strike", description: "A strike attack using acid.", training_cost: 0 },
      special: { damage: 36, probability: 0.47, label: "Acid Rain", description: "An attack that causes acid rain to fall on enemies.", training_cost: 5 }
    }
  },
  'Nuclear': {
    image: 'assets/snordeluxe_images/Nuclear/Nuclear.webp',
    battleImage: 'assets/snordeluxe_images/Nuclear/Nuclear.webp',
    mana: 1,
    level: 2,
    hitpoints: 200,
    weight: 22,
    analysis: 'Nuclear Snordeluxe channels radioactive energy to create devastating attacks.',
    attacks: {
      basic: { damage: 22, probability: 0.89, label: "Radiation Punch", description: "A punch attack using radiation.", training_cost: 0 },
      special: { damage: 56, probability: 0.47, label: "Nuclear Blast", description: "An attack that causes a nuclear explosion.", training_cost: 10 }
    }
  },
  'Water': {
    image: 'assets/snordeluxe_images/Water/Water.webp',
    battleImage: 'assets/snordeluxe_images/Water/water_nobg.png',
    coins: 100, gems: 1,
    level: 1,
    evolution: 'Ocean',
    hitpoints: 100,
    weight: 10,
    analysis: 'Water Snordeluxe controls the element of water, its attacks drenching opponents.',
    attacks: {
      basic: { damage: 10, probability: 0.9, label: "Splash Hit", description: "A hit attack using water.", training_cost: 0 },
      special: { damage: 30, probability: 0.5, label: "Tidal Wave", description: "An attack that creates a tidal wave.", training_cost: 5 }
    }
  },
  'Ocean': {
    image: 'assets/snordeluxe_images/Ocean/Ocean.webp',
    battleImage: 'assets/snordeluxe_images/Ocean/ocean_nobg.png',
    mana: 1,
    level: 2,
    evolution: 'Ice',
    hitpoints: 270,
    weight: 22,
    analysis: 'Ocean Snordeluxe commands the seas, its attacks causing massive waves.',
    attacks: {
      basic: { damage: 20, probability: 0.9, label: "Wave Crash", description: "A crash attack using ocean waves.", training_cost: 0 },
      special: { damage: 40, probability: 0.5, label: "Deep Sea Strike", description: "An attack that strikes with the power of the deep sea.", training_cost: 10 }
    }
  },
  'Ice': {
    image: 'assets/snordeluxe_images/Ice/Ice.webp',
    battleImage: 'assets/snordeluxe_images/Ice/ice_nobg.png',
    mana: 3,
    level: 3,
    hitpoints: 500,
    weight: 42,
    analysis: 'Ice Snordeluxe uses freezing attacks to immobilize and shatter its foes.',
    attacks: {
      basic: { damage: 30, probability: 0.9, label: "Frost Bite", description: "A bite attack using frost.", training_cost: 0 },
      special: { damage: 70, probability: 0.5, label: "Glacial Impact", description: "An attack that creates a massive glacial impact.", training_cost: 15 }
    }
  }
};

export { snordeluxeAssets };
